const setPresentation = (state: any, presentation: object) => {
  Object.assign(state, { presentation })
}

export default {
  setPresentation,
}
